import { AxiosResponse } from 'axios'
import { Moment } from 'moment'

import ClientSDK from '../../../App/ClientSDK'

import {
  IApiDeletedAppointment,
  IDeletedAppointment,
} from './IDeletedAppointment'
import Transformer from './Transformer'

export default class Client {
  static getDeletedAppointments(
    startDate: Moment,
    endDate: Moment,
  ): Promise<any> {
    return ClientSDK.instance()
      .get(
        `appointments-trash/${startDate.format('YYYY-MM-DD')}/${endDate.format(
          'YYYY-MM-DD',
        )}`,
      )
      .then((response: AxiosResponse) => {
        let appointments: IDeletedAppointment[] = []

        for (const date in response.data) {
          appointments = [
            ...appointments,
            ...response.data[date].map(
              (apiAppointment: IApiDeletedAppointment) =>
                Transformer.transform(apiAppointment),
            ),
          ]
        }
        return appointments
      })
  }
}
